import { refreshReducersToInitial } from "./refreshData-action";

export const REQUESTED_EPCS_STATUS = "REQUESTED_EPCS_STATUS" as const;
export const REQUESTED_EPCS_STATUS_SUCCESS = "REQUESTED_EPCS_STATUS_SUCCESS" as const;
export const REQUESTED_EPCS_STATUS_FAILED = "REQUESTED_EPCS_STATUS_FAILED" as const;
export const UPDATED_EPCS_STATUS = "UPDATED_EPCS_STATUS" as const;
export const REFRESH_EPCS_REDUCERS = "REFRESH_EPCS_REDUCERS" as const;
export const UPDATE_EPCSSTATUS_INCOMPLETE = "UPDATE_EPCSSTATUS_INCOMPLETE" as const;
export const UPDATE_EPCSSTATUS_RETRY = "UPDATE_EPCSSTATUS_RETRY" as const;

export const refreshEpcsStatus = () => ({ type: REFRESH_EPCS_REDUCERS } as const);
export const requestEpcsStatus = (requestdata) => ({ type: REQUESTED_EPCS_STATUS, payload: requestdata } as const);
export const requestEpcsStatusFailed = () => ({ type: REQUESTED_EPCS_STATUS_FAILED } as const);
export const requestEpcsStatusSuccess = (data) => ({ type: REQUESTED_EPCS_STATUS_SUCCESS, payload: data } as const);
export const updatedEpcsStatus = () => ({ type: UPDATED_EPCS_STATUS } as const);
export const updateEpcsStatusIncomplete = () => ({ type: UPDATE_EPCSSTATUS_INCOMPLETE } as const);
export const updateEpcsStatusRetry = (data) => ({ type: UPDATE_EPCSSTATUS_RETRY, payload: data } as const);

export type EPCSActions =
  | ReturnType<typeof refreshEpcsStatus>
  | ReturnType<typeof requestEpcsStatus>
  | ReturnType<typeof requestEpcsStatusFailed>
  | ReturnType<typeof requestEpcsStatusSuccess>
  | ReturnType<typeof updatedEpcsStatus>
  | ReturnType<typeof updateEpcsStatusIncomplete>
  | ReturnType<typeof updateEpcsStatusRetry>
  | ReturnType<typeof refreshReducersToInitial>;